import { IOS_APP_STORE_ID } from '@splitfiesta/shared';

import { isEmbeddedInMobileApp } from './embeddedMode';

/**
 * iOS Smart App Banner, added at runtime rather than in `index.html`.
 *
 * Safari decides on the banner from the `apple-itunes-app` meta element,
 * and the mobile app's in-app browser is Safari's own view controller —
 * so a static tag put the "install SplitFiesta" bar on every page opened
 * from inside the app. The app marks those pages (`?from=mobile-app`),
 * and that is only readable here, after load. WebKit picks the tag up
 * when it enters the document, which keeps the banner on the public
 * site; that is observed behaviour, not documented, so a real-device
 * check after major iOS releases is the only test there is.
 *
 * `app-argument` carries the page URL so an installed app opens this exact
 * page (an invite, a group) from the banner instead of its root.
 */
export function installSmartAppBanner(doc: Document = document): void {
  if (isEmbeddedInMobileApp()) return;
  if (!IOS_APP_STORE_ID) return;
  const meta = doc.createElement('meta');
  meta.name = 'apple-itunes-app';
  // The meta value is comma-separated; a comma in the URL must not start a new key.
  const argument = doc.location.href.replace(/,/g, '%2C');
  meta.content = `app-id=${IOS_APP_STORE_ID}, app-argument=${argument}`;
  doc.head.appendChild(meta);
}
